import anime from 'animejs/lib/anime.es.js';

const homeAnimation = () => {
  let img_home = document.querySelectorAll('.home__img-img');

  animateHomeBlock([...img_home]);

  function animateHomeBlock(it) {
     anime({
      targets: it[0],
      opacity: 1,
      keyframes: [{ translateY: -1 }, { translateY: 0 }],
      duration: 4000,
      easing: 'easeOutElastic(1, .8)',
    });
    anime({
      targets: it[1],
      opacity: 1,
      keyframes: [{ translateY: -1 }, { translateY: 0 }],
      delay: 300,
      duration: 4000,
      easing: 'easeOutElastic(1, .8)',
    });
    anime({
      targets: it[2],
      opacity: 1,
      keyframes: [{ translateY: -1 }, { translateY: 0 }],
      delay: 600,
      duration: 4000,
      easing: 'easeOutElastic(1, .8)',
    });
  }
};

export default homeAnimation;
